import React from 'react';

export const BackgroundTitle = ({ title }) => (
  <div className='background-title'>
    <h1>{title}</h1></div>
);
